module.exports = __webpack_public_path__ + "static/img/yn-bio.0766129.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/yn-bio.png
// module id = HcNq
// module chunks = 1